/**
 * Canonical enumerations shared by the web client and the API.
 * These mirror the CHECK constraints in migrations/ — keep them in sync.
 */

export const USER_ROLES = ["lawyer", "client"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const MATTER_STATUSES = [
  "intake",
  "active",
  "on_hold",
  "closed",
  "archived",
] as const;
export type MatterStatus = (typeof MATTER_STATUSES)[number];

export const INVOICE_STATUSES = ["draft", "pending", "paid", "overdue"] as const;
export type InvoiceStatus = (typeof INVOICE_STATUSES)[number];

export const PAYMENT_METHODS = [
  "upi",
  "bank_transfer",
  "cash",
  "cheque",
  "card",
  "other",
] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const THEMES = ["chambers", "minimal", "dark"] as const;
export type ThemeId = (typeof THEMES)[number];

/**
 * Password verification scheme.
 * - "relief": the browser derives a bcrypt proof (cost >= 10) and the Worker
 *   verifies a SHA-256 of it — total server CPU ~0.1ms, which fits the
 *   Workers Free 10ms/request CPU budget. See apps/web/src/auth/proof.ts and
 *   docs/ARCHITECTURE.md.
 * - "server": classic server-side bcrypt verification (~60-100ms CPU; only
 *   viable on the Workers Paid plan).
 */
export const AUTH_MODES = ["relief", "server"] as const;
export type AuthMode = (typeof AUTH_MODES)[number];

/** Suggested matter/case types for the lawyer's form (free text is allowed). */
export const CASE_TYPE_SUGGESTIONS = [
  "Civil",
  "Criminal",
  "Family",
  "Property",
  "Corporate & Commercial",
  "Consumer",
  "Tax",
  "Arbitration & ADR",
  "Constitutional",
  "Labour & Service",
  "Other",
] as const;
